import { Schema } from "@effect/schema";
import { ProtocolKey } from "../protocol";
import { Address } from "../address";
import { MarketAssetMeta } from "../market-asset/market-asset-meta";
import { ChainKey } from "../chain";

export type MarketMeta = typeof MarketMeta.Type;
export type MarketMetaEncoded = typeof MarketMeta.Encoded;

export const MarketMeta = Schema.Struct({
  protocolKey: ProtocolKey,
  chainKey: ChainKey,
  marketAddress: Address,
  isDeprecated: Schema.Boolean,
  baseAsset: MarketAssetMeta,
  bridgeAssets: Schema.Tuple(
    MarketAssetMeta,
    Schema.optionalElement(MarketAssetMeta)
  ),
}).annotations({ identifier: "MarketMeta" });
